const Secondary = {
  color1: '#6DB8FF',
  color2: '#FFB74D',
  color3: '#E57373',
  color4: '#AED581',
  color5: '#9575CD',
  color6: '#78AFD1',
  color7: '#F06292',
  color8: '#4DCFE1',
  color9: '#BA68C8',
  color10: '#FF8A65',
  color11: '#50C4F7',
  color12: '#81C784',
  color13: '#D07F83',
  color14: '#80DEEA',
  color15: '#7986CB',
  color16: '#F48FB0',
  color17: '#FFAA91',
  color18: '#C5E1A5',
  color19: '#4DB6AC',
  color20: '#E69DEB',
};

export { Secondary };
